import React, { Fragment, useEffect, useState } from 'react'
import Logo from "../../images/logo-black.png"
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom";
import { resetPasswordAction, clearErrors } from '../../../redux/actions/userActions'
import Loader from "../../loader/loader"


const ResetPassword = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { token } = useParams();

  const { loading, isAuthenticated, error } = useSelector((state) => state.verifyEmailStore)



  const [newPassword, setNewPassword] = useState()
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSubmit, setIssubmit] = useState()
  const [showPassword, setShowPassword] = useState(false)



  const handleSubmit = (e) => {
    e.preventDefault()

    if (newPassword !== confirmPassword) {
      toast.error('passwords does not match')
      return
    }

    if (!newPassword) {
      toast.error("please Enter your password")
      return
    }

    if (!newPassword && newPassword.length < 8) {
      toast.error("please Enter atleast 8 digits for password")
      return
    }


    if (!token) {
      toast.error('invalid reset password link')
      return
    }

    const passwordsObject = {
      password: newPassword,
      confirmPassword,
    }



    dispatch(resetPasswordAction(passwordsObject, token))


    setIssubmit(true)
  }




  useEffect(() => {
    if (isAuthenticated) {
      navigate('/')
    }
    if (error && isSubmit) {
      toast.error(error)
      dispatch(clearErrors())
      setIssubmit(false)
    }

    document.title = `RESET PASSWORD`;

  }, [error, isAuthenticated, dispatch, navigate, isSubmit])



  
  return (
    <Fragment>
      {
        loading ? <Loader /> :
          <section className="min-h-screen w-full bg-[#F8FAFC] flex items-center justify-center p-4 relative overflow-hidden font-jakarta">
            {/* Subtle Background Decorations */}
            <div className="absolute top-[-20%] left-[-10%] w-[40vmax] h-[40vmax] bg-gradient-to-br from-blue-50 to-indigo-50 rounded-full filter blur-3xl opacity-70"></div>
            <div className="absolute bottom-[-20%] right-[-10%] w-[40vmax] h-[40vmax] bg-gradient-to-tl from-purple-50 to-pink-50 rounded-full filter blur-3xl opacity-70"></div>

            {/* Logo at top left */}
            <div className='absolute top-8 left-8'>
              <Link to={'/'}>
                <img src={Logo} alt="Zonify Pro" className='w-32' />
              </Link>
            </div>

            <div className="relative z-10 max-w-md w-full bg-white border border-zinc-100 rounded-3xl p-10 shadow-[0_20px_50px_rgba(0,0,0,0.05)] flex flex-col items-center">
              
              {/* Icon Container (Lock) */}
              <div className="mb-6 relative">
                <div className="absolute inset-0 bg-zinc-50 rounded-full scale-110"></div>
                <div className="relative w-16 h-16 bg-white rounded-full shadow-sm flex items-center justify-center border border-zinc-100">
                  <i className="fa-solid fa-lock text-zinc-900 text-xl"></i>
                </div>
              </div>

              {/* Heading */}
              <h1 className="text-2xl font-bold text-zinc-900 mb-2 text-center tracking-tight">
                Set new password
              </h1>
              <p className="text-zinc-500 text-sm text-center mb-8">
                Enter a secure password and confirm it.
              </p>

              <form className="w-full flex flex-col" onSubmit={handleSubmit}>
                {/* New Password */}
                <div className="flex flex-col mb-5 relative">
                  <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">New Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                      placeholder="••••••••"
                    />
                    <button type="button"
                      className="absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-400 hover:text-zinc-600 transition-colors"
                      onClick={() => setShowPassword(prev => !prev)}>
                      <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="flex flex-col mb-6 relative">
                  <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Confirm Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="w-full px-4 py-3 rounded-xl border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                      placeholder="••••••••"
                    />
                    <button type="button"
                      className="absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-400 hover:text-zinc-600 transition-colors"
                      onClick={() => setShowPassword(prev => !prev)}>
                      <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-zinc-900 text-white font-medium py-3 rounded-xl hover:bg-zinc-800 transition-all duration-200 shadow-sm"
                >
                  Change Password
                </button>
              </form>
            </div>
          </section>
      }

    </Fragment>
  )
}

export default ResetPassword